import styled from 'styled-components';
import { mq, getGridSpans, getSpace, getColor, getTextType } from '../../../stylesheets/tools';

const StyledShapedStage = styled.section`
  position: relative;
  display: block;
  width: 100%;
  margin-bottom: ${getSpace('l')};

  .campaignStage__video-control {
    width: 40px;
    height: 40px;
    border-radius: 100%;
    position: absolute;
    bottom: 15px;
    right: 20px;
    z-index: 20;
    color: ${getColor('white')};
    background: ${getColor('greenTwo')};
    // mix-blend-mode: overlay;
    transition: all 0.2s ease-in-out;

    &:hover {
      background: ${getColor('white')};
      color: ${getColor('black')};
    }

    ${mq('m')} {
      bottom: 30px;
      right: 30px;
      width: 40px;
      height: 40px;
    }
  }

  .campaignStage__link-container {
    position: absolute;
    top: 120px;
    right: 0px;
    z-index: 3;

    .campaignStage__link-inner-container {
      position: relative;
      width: 120px;
      padding: 15px 0;

      ${mq('m')} {
        width: 130px;
      }
    }
    .campaignStage__link {
      ${getTextType('copyThick', 'international')};
      color: white;

      .campaignStage__inner-link {
        display: block;
        transform: rotate(-38deg);
        margin-left: -13px;
        line-height: 1.25;
        margin-bottom: -35px;
        word-break: break-all;
        font-size: 13px;

        ${mq('m')} {
          margin-bottom: -45px;
          font-size: 16px;
        }
      }
      .campaignStage__stretched-link {
        position: absolute;
        inset: 0;
        z-index: 2;
      }
    }

    &:hover {
      .campaignStage__arrow {
        background: #ffffff;
        color: ${getColor('black')};
      }
    }

    .campaignStage__arrow {
      width: 100%;
      height: 100%;
      aspect-ratio: 3/5;
      background: ${getColor('greenTwo')};
      clip-path: polygon(0 48%, 100% 0, 100% 100%, 25% 77%);
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${getColor('white')};
      transition: all 0.2s ease-in-out;

      svg {
        width: 50px;
        transform: rotate(-38deg);
      }
    }
  }
  .campaignStage__wrapper {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    ${mq('m')} {
      flex-direction: row;
      aspect-ratio: 16/9;
      height: 100%;
      max-height: 100vh;

      @supports not (aspect-ratio: 16 / 9) {
        width: 100%;
        height: 100vh;
      }
    }

    > div:last-child {
      position: absolute;
      left: 0;
      padding-top: max(20vw, 120px);
      bottom: 60px;

      ${mq('m')} {
        bottom: 40px;
        padding-top: 0;
      }
    }

    .container__wrapper {
      height: 100%;
      width: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;

      ${mq('l')} {
        max-width: 680px;
      }
    }
  }

  .campaignStage__anchor-nav {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
    color: black;

    ${mq('s')} {
      justify-content: start;
      height: 100%;
    }

    .campaignStage__anchor-nav-link {
      .filter-tag__title {
        color: black;
        padding: 5px 0 2px 0;
        font-size: 16px;
        z-index: 5;
        transition: all 0.2s ease-in-out;
      }

      &:hover {
        .filter-tag {
          &:before {
            opacity: 1;
          }
          .filter-tag__title {
            color: #000;
          }
        }
      }

      &:not(:hover) {
        .filter-tag:before {
          // mix-blend-mode: overlay;
          // -webkit-backface-visibility: visible;
        }
      }

      .filter-tag:before {
        color: ${getColor('white')};
        z-index: 2;
        opacity: 0.75;
        transition: all 0.2s ease-in-out;
        border-radius: 4px;
      }
    }
  }
  .campaignStage__media {
    width: 100%;
    height: min-content;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-end;

    ${mq('m')} {
      height: 100%;
      align-items: center;
    }

    &--desktop {
      display: none;

      ${mq('m')} {
        display: block;
      }
    }

    &--mobile {
      display: block;
      ${mq('m')} {
        display: none;
      }
    }

    &--overlay {
      width: 100%;
      height: 100%;
      z-index: 1;
      background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.6) 0%,
        rgba(0, 0, 0, 0) 40%,
        rgba(0, 0, 0, 0) 100%
      );
    }

    img,
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      bottom: 0;
    }
  }

  .campaignStage__headline {
    max-width: 480px;
    color: ${getColor('white')};
    padding-bottom: ${getSpace('xs')};
    ${getGridSpans('width', { s: 12, m: 10, l: 12 })};
    text-align: center;
    z-index: 3;

    & > div > p {
      margin-top: ${getSpace('m')};
      margin-bottom: ${getSpace('m')};

      ${mq('m')} {
        margin-top: ${getSpace('m')};
        margin-bottom: ${getSpace('l')};
      }
    }
    ${mq('m')} {
      text-align: left;
    }

    ${mq('m')} {
      & > div > p,
      & > .campaignStage__link {
        margin-left: ${getSpace('l')};
      }
    }
  }

  .campaignStage__subline,
  .campaignStage__copy {
    position: relative;
    margin: 0;
    ${getGridSpans('margin-left', { s: [1, 'spread'] })}
    ${getGridSpans('margin-right', { s: [1, 'spread'] })}
    padding-left: 2px;
    display: block;
    z-index: 2;
  }

  .mainStage__curtain-right,
  .mainStage__curtain-left {
    position: fixed;
    height: 120vh;
    box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.1);
    z-index: 1;
    transition: transform 0.2s cubic-bezier(0.48, 0, 0.5, 1);
  }

  .mainStage__curtain-left {
    width: 150vw;
    top: 70vh;
    left: 0;
    transform: translateY(100%) rotate(15deg);
    transform-origin: top left;
    background: ${props => props.theme.globalTheme.secondary};

    ${mq('m')} {
      top: 60vh;
    }
  }

  .mainStage__curtain-right {
    height: 120vh;
    width: 150vw;
    top: 50vh;
    right: 0;
    left: auto;
    transform: translateY(100%) rotate(-50deg);
    transform-origin: top right;
    background: ${props => props.theme.globalTheme.tertiary};

    ${mq('m')} {
      height: 120vh;
      width: 150vw;
      top: -20vh;
      right: 0;
    }
  }

  ${mq('xxl', 'min')} {
    .campaignStage__headline {
      max-width: 680px;

      h1 {
        font-size: 6rem;
        line-height: 1;
      }
    }

    .campaignStage__anchor-nav {
      gap: 10px;
    }
    .campaignStage__anchor-nav-link .filter-tag .filter-tag__title {
      font-size: 18px;
      color: black;
    }
  }
`;

export default StyledShapedStage;
